import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
  ButtonBase,
  Card,
  CardContent,
  CardMedia,
  Typography,
} from '@mui/material';

interface GridCardProps {
  title: string;
  subtitle: string;
  imagePath: string;
}

export default function GridCard({
  title,
  subtitle,
  imagePath,
}: GridCardProps) {
  const navigate = useNavigate();

  return (
    <ButtonBase onClick={() => navigate(title.toLowerCase())}>
      <Card>
        <CardMedia component='img' height='180' image={imagePath} alt={title} />
        <CardContent>
          <Typography gutterBottom variant='h5' component='div'>
            {title}
          </Typography>
          <Typography variant='body2' color='text.secondary'>
            {subtitle}
          </Typography>
        </CardContent>
      </Card>
    </ButtonBase>
  );
}
